theme.Yotpo = {
  enabled: true,
  yotpoUrl: 'https://cdn-widgetsrepository.yotpo.com/v1/loader/VDC0UlGBZAONh3AQEdnG0PEWADqhjyiFpfWsXcCD?languageCode={{ localization.language.iso_code | escape }}',
  load: function() {
    if (this.enabled) {
      //add a new tag for the yotpo script
      var e = document.createElement("script");
      e.type="text/javascript";
      e.async=true; 
      e.src= this.yotpoUrl;
      var t = document.getElementsByTagName("script")[0];
      t.parentNode.insertBefore(e,t);
    }
  },
  reload: function() {
    if (yotpo) {
      yotpo.init().initialized = false;
      yotpo.init();
    }
  }
};